/**
 * @class InputSelect
 * @classdesc Represents an input of type select
 *
 * @extends Core.Component
 */
export default class InputSelect extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.inputEl = el.querySelector('[data-input]');
    this.labelEl = el.querySelector('[data-label]');
  }

  get value() {
    return this.inputEl.value;
  }

  set value(value) {
    this.inputEl.value = value;
  }

  /**
   * Returns the select label
   */
  get label() {
    return this.labelEl.innerHTML;
  }

  /**
   * Sets the select label
   *
   * @param {HTMLElement|DOMString|string} content - The content to replace the
   *                                       current labels content with.
   */
  set label(content) {
    if (content instanceof HTMLElement) {
      this.labelEl.innerHTML = '';
      this.labelEl.appendChild(content);
    } else {
      this.labelEl.innerHTML = content;
    }
  }

  disableValues(values) {
    const existingOptions = this.inputEl.querySelectorAll('option');

    existingOptions.forEach(existingOption => {
      if (values.some(value => value === existingOption.value)) {
        existingOption.setAttribute('disabled', '');
      }
    });

    return null;
  }

  removeValues(values) {
    const existingOptions = this.inputEl.querySelectorAll('option');

    existingOptions.forEach(existingOption => {
      if (values.some(value => value === existingOption.value)) {
        existingOption.remove();
      }
    });

    return null;
  }
}
